import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommentConfig } from 'src/app/models/comment-config.model';
import { Comment } from 'src/app/models/comment.model';

@Component({
  selector: 'app-comment-section',
  templateUrl: './comment-section.component.html',
  styleUrl: './comment-section.component.scss'
})
export class CommentSectionComponent implements OnInit {
  
  @Input()
  public config: CommentConfig;

  @Input()
  public comments: Comment[] = [];

  //szerkeszthető a felület bármelyik része
  @Input()
  public isEditable: boolean = true;

  @Input()
  public isShowDeleteButton: boolean = true;

  @Input()
  public singleComments: boolean = false;

  @Input()
  public isAutoSave: boolean = true;

  @Input()
  public isCommentHeaderVisible = true;

  @Input()
  public displayStyle = 'style-1';

  @Input()
  public textareaLabel = 'Hozzászólás';

   @Output() 
   public change = new EventEmitter<Comment>();

   @Output() 
   public delete = new EventEmitter<Comment>();

  // properties

  // check if the current user is allowed to add a comment, and it has not commented yet
  public get isAllowAdd(): boolean {
    return this.isEditable && (!this.singleComments || this.myCommentCount === 0) && !this.hasCommentForCurrentEmployee;
  }  

  public get myCommentCount(): number {
    return this.comments.filter(x => x.employeeId === this.config.employeeId && x.message).length;
  }

  public get hasCommentForCurrentEmployee(): boolean {
    return this.comments.findIndex(x => x.employeeId === this.config.employeeId && x.message) !== -1;
  }

  // properties end

  // check if the current user is the author of the comment, 
  public isAllowEdit(comment: Comment): boolean {
    return this.isEditable && this.isOwnComment(comment);
  }

  public isAllowDelete(comment: Comment): boolean {
    return this.isEditable && this.isOwnComment(comment) && !!comment.id;
  }

  public isOwnComment(comment: Comment): boolean {
    return comment.employeeId === this.config.employeeId;
  }

  public showEditComment(comment: Comment): boolean {
    return this.isEditable && this.isOwnComment(comment);
  }

  constructor() {
    
  }
  
  ngOnInit(): void {
    
  }

  saveComment(comment: Comment) {
    this.change.emit(comment);
  }

  deleteComment(comment: Comment) {
    this.delete.emit(comment);
  }

}
